import React from 'react'
import { Outlet } from 'react-router-dom'
import PageTabs from '../shared/PageTabs.jsx'
import '../../styles/pages.css'

const tabs = [
  { path: '/pim/products', label: 'Products' },
  { path: '/pim/brands', label: 'Brands' },
  { path: '/pim/categories', label: 'Categories' },
  { path: '/pim/dimensions', label: 'Dimensions' },
  { path: '/pim/review', label: 'Review' }
]

function PIMPage() {
  return (
    <div className="page">
      <div className="pageHead">
        <h1>Product Information</h1>
        <p>Manage master products, brands, categories, and dimensions</p>
      </div>

      {/* "section": /pim/brands/:id must keep the Brands tab lit. */}
      <PageTabs tabs={tabs} match="section" />

      <div style={{ marginTop: 28 }}>
        <Outlet />
      </div>
    </div>
  )
}

export default PIMPage
